module.exports = __webpack_public_path__ + "img/7.1fc0ea6f.jpg";